import { React, useState } from "react";
import { useTranslation } from "react-i18next";

const Footer = ({ logo }) => {
  const { i18n } = useTranslation();

  function handleLangChange(s = "") {
    window.location = `/csr/${s}`;
  }

  return (
    <div
      style={{ borderTop: "6px solid #ff8350" }}
      id="contact"
      className="setBorder flex flex-row flex-wrap items-center justify-center p-5 border-2 lg:mt-5 "
    >
      <button className="mr-10" onClick={() => handleLangChange()}>
        🇲🇨 Indonesia
      </button>
      <button onClick={() => handleLangChange("en")}>
       🇺🇸 English
      </button>
    </div>
  );
};

export default Footer;
